/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 08 2024
 **/

export default function checkHasLink(
	chatForm: ChatServices.Format2.Container.Richtext | ChatServices.Format2.Elements.Section
) {
	let result = false;
	chatForm.elements.forEach((v) => {
		if (v.type === "link") result = true;
		if (v.type === "section") {
			result = checkHasLink(v);
		}
	});
	return result;
}
